import React from 'react';
import { Link } from 'react-router-dom';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import styles from './FundWallet.module.css';

export default function FundWallet() {
    return (
        <div>
            <HeaderNav />
            <main className={styles.container}>
                <h1 className={styles.title}>Fund Wallet</h1>
                <p className={styles.subtitle}>Add money to your wallet to pay your subscriptions</p>

                <div className={styles.grid}>
                    <section className={styles.leftCard}>
                        <div className={styles.inputBox}>
                            <label>Enter Amount</label>
                            <div className={styles.amount}>₦0.00</div>
                            <div className={styles.min}>Minimum amount: ₦100.00</div>
                        </div>

                        <div className={styles.presets}>
                            <button>₦5,000</button>
                            <button>₦10,000</button>
                            <button>₦15,000</button>
                            <button>₦20,000</button>
                            <button>₦25,000</button>
                        </div>

                        <div className={styles.transferInfo}>
                            <h4>Transfer to your Wallet Account</h4>
                            <p className={styles.muted}>Use these account details to fund your wallet from any bank app or USSD</p>

                            <div className={styles.infoRow}>
                                <div>
                                    <div className={styles.label}>Bank Name</div>
                                    <div className={styles.value}>Providus Bank</div>
                                </div>
                                <button className={styles.copy}>Copy</button>
                            </div>

                            <div className={styles.infoRow}>
                                <div>
                                    <div className={styles.label}>Wallet ID</div>
                                    <div className={styles.value}>0123456789</div>
                                </div>
                                <button className={styles.copy}>Copy</button>
                            </div>

                            <div className={styles.infoRow}>
                                <div>
                                    <div className={styles.label}>Wallet Name</div>
                                    <div className={styles.value}>Johnson Ojo</div>
                                </div>
                                <button className={styles.copy}>Copy</button>
                            </div>

                            <div className={styles.note}>Important: Transfers are usually credited within 5-10 minutes.</div>

                            <Link to="/wallet" className={styles.confirmButton}>I have made Payment</Link>
                        </div>
                    </section>

                    <aside className={styles.rightCard}>
                        <div className={styles.walletInfo}>
                            <h3>Wallet Information</h3>
                            <div className={styles.balanceLabel}>Current Balance</div>
                            <div className={styles.balance}>₦30,000.00</div>

                            <div className={styles.howto}>
                                <h4>How to Fund Your Wallet</h4>
                                <ol>
                                    <li>Copy the account details above</li>
                                    <li>Open your bank app or dial your bank's USSD code</li>
                                    <li>Transfer any amount to the account</li>
                                    <li>Wait 5-10 minutes for confirmation</li>
                                </ol>
                            </div>
                        </div>
                    </aside>
                </div>
            </main>
        </div>
    );
}
